class WaitlistPopupButton extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    const formId = this.getAttribute('form-id');
    
    if (!formId) {
      console.warn('WaitlistPopupButton: No form-id attribute provided');
      return;
    }

    this.setAttribute('role', 'button');
    this.setAttribute('tabindex', '0');

    if (!this.hasAttribute('aria-label')) {
      const visibleText = this.textContent.trim();
      if (visibleText) {
        this.setAttribute('aria-label', visibleText);
      } else {
        this.setAttribute('aria-label', 'Join the Waitlist');
      }
    }

    this.addEventListener('click', (e) => {
      e.preventDefault();
      this.openKlaviyoForm(formId);
    });

    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.openKlaviyoForm(formId);
      }
    });

    if (!this.hasAttribute('style') || !this.style.cursor) {
      this.style.cursor = 'pointer';
    }
  }

  openKlaviyoForm(formId) {
    if (!window._klOnsite) {
      window._klOnsite = [];
    }
    window._klOnsite.push(['openForm', formId]);
  }
}

if (!customElements.get('waitlist-popup-button')) {
  customElements.define('waitlist-popup-button', WaitlistPopupButton);
}
